var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "mb-3" },
    [
      _c(
        "div",
        { staticClass: "container-fluid pt-lg-1" },
        [
          _c(
            "div",
            { staticClass: "d-flex justify-content-between align-items-end" },
            [
              _c("ob1-breadcrumb", {
                staticClass: "me-2 breadcrumb-full",
                staticStyle: { "min-width": "0" },
                attrs: { items: _vm.breadcrumbItems },
              }),
              _vm._v(" "),
              !_vm.searchMode
                ? _c("cart-banner", {
                    attrs: {
                      "cart-link": _vm.dto.cart ? _vm.dto.cart.url : null,
                      "number-of-items": _vm.dto.cart
                        ? _vm.dto.cart.numberOfItems
                        : 0,
                      "cart-enabled": !!_vm.dto.cart,
                    },
                  })
                : _vm._e(),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "div",
            {
              staticClass: "d-flex flex-wrap align-items-center mb-2",
              class: _vm.searchMode ? "justify-content-md-end" : "",
              attrs: { id: "top" },
            },
            [
              !_vm.searchMode
                ? _c("h1", {
                    staticClass: "mb-0",
                    attrs: { id: "header-title" },
                    domProps: { innerHTML: _vm._s(_vm.headerTitle) },
                  })
                : _vm._e(),
              _vm._v(" "),
              _c(
                "div",
                { class: _vm.searchMode ? "w-75" : "ms-auto col-12 col-md-4" },
                [
                  _vm.searchFilters
                    ? _c("equipment-search-field", {
                        attrs: {
                          "place-holder":
                            _vm.searchFilters.cartBannerSearchLabel,
                          "search-results-url":
                            _vm.searchFilters.searchResultsUrl,
                          "search-results-query-additional-params":
                            _vm.searchFilters
                              .searchResultsQueryAdditionalParams,
                          "algolia-api-key":
                            _vm.searchFilters.algoliaDto.apiKey,
                          "algolia-app-id": _vm.searchFilters.algoliaDto.appId,
                          "algolia-index-name":
                            _vm.searchFilters.algoliaDto.indexName,
                          "enable-search-algolia":
                            _vm.searchFilters.enableSearchAlgolia,
                          "device-list-search-url":
                            _vm.searchFilters.deviceListSearchUrl,
                          "tms-category": "lr-boutique-completion",
                          "tms-button-action": "search",
                          "tms-result-action": "clic-autre-compl-",
                        },
                      })
                    : _vm._e(),
                ],
                1
              ),
            ]
          ),
          _vm._v(" "),
          _vm.currentDepartment
            ? _c("CategoryTabs", {
                staticClass: "mb-1",
                attrs: {
                  "aria-label": "Catégories de produits",
                  "active-tab-id": _vm.currentDepartment.id,
                  tabs: _vm.departments,
                },
                on: {
                  "tab-click": function ($event) {
                    return _vm.handleChangeDepartment($event)
                  },
                },
              })
            : _vm._e(),
          _vm._v(" "),
          _c("hr", {
            staticClass: "separator separator--gray4 d-none d-xl-block",
          }),
          _vm._v(" "),
          _c("div", { staticClass: "row" }, [
            _c(
              "section",
              {
                staticClass:
                  "col-12 col-xl-4 col-xxl-3 filters-sidebar d-none d-xl-block border-end border-gray4",
                attrs: { "aria-label": "Filtres des produits" },
              },
              [
                _c("bouton", {
                  staticClass: "visually-hidden-focusable",
                  attrs: {
                    label: "Sauter les filtres et atteindre les résultats",
                    "is-primary": false,
                  },
                  on: {
                    click: function ($event) {
                      return _vm.skipFilters()
                    },
                  },
                }),
                _vm._v(" "),
                _c(
                  "h2",
                  {
                    staticClass: "visually-hidden",
                    attrs: { id: "filters-title-desktop" },
                  },
                  [
                    _vm._v(
                      "\n                    Filtrer par\n                "
                    ),
                  ]
                ),
                _vm._v(" "),
                _c("div", { ref: "filtersDesktopTarget" }),
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "div",
              {
                staticClass:
                  "col-12 d-xl-none d-flex gap-md-1 w-100 mb-1 px-0 px-md-1 border-bottom-md-none border-bottom border-gray4",
              },
              [
                _c(
                  "div",
                  {
                    staticClass:
                      "flex-fill flex-basis-0 bg-gray2 d-flex justify-content-center align-items-center padding-button border-end-md-none border-end border-gray4",
                  },
                  [
                    _c(
                      "h2",
                      {
                        staticClass: "visually-hidden",
                        attrs: { id: "sort-title" },
                      },
                      [
                        _vm._v(
                          "\n                        Trier par\n                    "
                        ),
                      ]
                    ),
                    _vm._v(" "),
                    _c("ob1-liens-icone", {
                      attrs: {
                        "is-button": "",
                        "modal-id": "sort-modal",
                        title: "Trier",
                        "data-bs-toggle": "modal",
                        icon: "icon-filter",
                        type: "button",
                      },
                    }),
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "div",
                  {
                    staticClass:
                      "flex-fill flex-basis-0 bg-gray2 d-flex justify-content-center align-items-center padding-button",
                  },
                  [
                    _c("ob1-liens-icone", {
                      staticClass: "ms-1",
                      attrs: {
                        "is-button": "",
                        "modal-id": "filters-modal",
                        title: "Filtrer",
                        "data-bs-toggle": "modal",
                        icon: "icon-configuration-contrat",
                        type: "button",
                      },
                    }),
                  ],
                  1
                ),
              ]
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "col-12 col-xl-8 col-xxl-9 main-content-sidebar" },
              [
                _c("div", { staticClass: "mb-1 mt-xl-1" }, [
                  _c(
                    "div",
                    { staticClass: "d-flex" },
                    [
                      _c(
                        "div",
                        {
                          staticClass: "pe-1",
                          staticStyle: { "white-space": "nowrap" },
                          attrs: { id: "total-devices" },
                        },
                        [
                          _c(
                            "p",
                            {
                              staticClass:
                                "font-size-16 lead fw-bold mb-0 me-1",
                            },
                            [
                              _c("span", { staticClass: "aria-hidden" }, [
                                _vm._v(_vm._s(_vm.resultsLabel)),
                              ]),
                              _vm._v(" "),
                              _c(
                                "output",
                                {
                                  staticClass: "visually-hidden",
                                  attrs: { id: "results-number-accessible" },
                                },
                                [
                                  _vm._v(
                                    "\n                                    " +
                                      _vm._s(
                                        _vm.filtersAndSortAccessibleLabel
                                      ) +
                                      "\n                                "
                                  ),
                                ]
                              ),
                            ]
                          ),
                        ]
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        {
                          staticClass:
                            "chips-filters d-flex ps-1 flex-xl-wrap flex-nowrap overflow-x-auto position-relative",
                          class:
                            _vm.numberOfSelectedFilters > 0
                              ? "border-start border-gray3 flex-fill"
                              : "flex-fill",
                        },
                        [
                          _vm.orangeOnly
                            ? _c("ob1-input-chips", {
                                attrs: {
                                  id: "chip-orangeOnly",
                                  "additional-classes": "mb-1 me-1",
                                  label: "Vendu uniquement par Orange",
                                },
                                on: {
                                  "ob1-input-chips-click": function ($event) {
                                    return _vm.toggleOrangeOnly(true)
                                  },
                                },
                              })
                            : _vm._e(),
                          _vm._v(" "),
                          _vm._l(
                            _vm.selectedSelectorsCheckboxes,
                            function (selectedSelector) {
                              return _c("ob1-input-chips", {
                                key: selectedSelector.name,
                                attrs: {
                                  id: "chip-" + selectedSelector.id,
                                  "additional-classes": "mb-1 me-1",
                                  label: selectedSelector.name,
                                },
                                on: {
                                  "ob1-input-chips-click": function ($event) {
                                    return _vm.toggleSelector(
                                      selectedSelector.id,
                                      false,
                                      true
                                    )
                                  },
                                },
                              })
                            }
                          ),
                          _vm._v(" "),
                          _vm._l(
                            _vm.selectedBrandsCheckboxes,
                            function (selectedBrand) {
                              return _c("ob1-input-chips", {
                                key: selectedBrand.name,
                                attrs: {
                                  id: "chip-" + selectedBrand.id,
                                  "additional-classes": "mb-1 me-1",
                                  label: selectedBrand.name,
                                },
                                on: {
                                  "ob1-input-chips-click": function ($event) {
                                    return _vm.toggleBrand(
                                      selectedBrand.id,
                                      false,
                                      true
                                    )
                                  },
                                },
                              })
                            }
                          ),
                          _vm._v(" "),
                          _vm._l(
                            _vm.selectedPricesCheckboxes,
                            function (selectedPrice) {
                              return _c("ob1-input-chips", {
                                key: selectedPrice.name,
                                attrs: {
                                  id: "chip-" + selectedPrice.id,
                                  "additional-classes": "mb-1 me-1",
                                  label: selectedPrice.name,
                                },
                                on: {
                                  "ob1-input-chips-click": function ($event) {
                                    return _vm.togglePrice(
                                      selectedPrice.id,
                                      false,
                                      true
                                    )
                                  },
                                },
                              })
                            }
                          ),
                          _vm._v(" "),
                          _vm._l(
                            _vm.selectedNotesCheckboxes,
                            function (selectedNote) {
                              return _c("ob1-input-chips", {
                                key: selectedNote.name,
                                attrs: {
                                  id: "chip-" + selectedNote.id,
                                  "additional-classes": "mb-1 me-1",
                                  label: selectedNote.name,
                                },
                                on: {
                                  "ob1-input-chips-click": function ($event) {
                                    return _vm.toggleNote(
                                      selectedNote.id,
                                      false,
                                      true
                                    )
                                  },
                                },
                              })
                            }
                          ),
                          _vm._v(" "),
                          _vm._l(
                            _vm.selectedStatusCheckboxes,
                            function (statusChip) {
                              return _c("ob1-input-chips", {
                                key: statusChip.name,
                                attrs: {
                                  id: "chip-" + statusChip.id,
                                  "additional-classes": "mb-1 me-1",
                                  label: statusChip.name,
                                },
                                on: {
                                  "ob1-input-chips-click": function ($event) {
                                    return _vm.toggleStatus(
                                      statusChip.id,
                                      false,
                                      true
                                    )
                                  },
                                },
                              })
                            }
                          ),
                          _vm._v(" "),
                          _vm.numberOfSelectedFilters > 0
                            ? _c("ob1-liens-icone", {
                                staticClass: "mb-1 py-0 flex-shrink-0",
                                attrs: {
                                  "is-button": "",
                                  title: "Tout effacer",
                                  icon: "icon-trash",
                                  type: "button",
                                },
                                on: { click: _vm.onDeleteSelectionClick },
                              })
                            : _vm._e(),
                        ],
                        2
                      ),
                      _vm._v(" "),
                      _c("ob1-drop-down", {
                        staticClass: "ms-3 d-none d-xl-block flex-shrink-0",
                        attrs: {
                          id: "mobile-sortBy-desktop",
                          "is-button": true,
                          "drop-down-dto": _vm.dto.dropDownDto,
                        },
                        on: { "ob1-drop-item-click": _vm.sortAccessories },
                      }),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "slide-popin-modal d-xl-none" },
                    [
                      _c(
                        "slide-popin-modal-filter",
                        {
                          attrs: {
                            id: "sort-modal",
                            "aria-labelledby": "sort-title",
                            "button-label": "Valider la selection",
                          },
                        },
                        [
                          _c("device-sort", {
                            attrs: {
                              "sort-radio-buttons": _vm.sortRadioButtons,
                            },
                            on: { "sort-item-click": _vm.sortAccessories },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "slide-popin-modal d-xl-none" },
                    [
                      _c(
                        "slide-popin-modal-filter",
                        {
                          attrs: {
                            id: "filters-modal",
                            "aria-labelledby": "filters-title",
                            "delete-selection-label": _vm.deleteSelectionLabel,
                            "number-of-selected-filters":
                              _vm.numberOfSelectedFilters,
                            "button-label": _vm.dto.filtersButtonLabel,
                          },
                          on: {
                            "delete-selection-click":
                              _vm.onDeleteSelectionClick,
                          },
                        },
                        [
                          _c(
                            "h2",
                            {
                              staticClass: "visually-hidden",
                              attrs: { id: "filters-title" },
                            },
                            [
                              _vm._v(
                                "\n                                Filtrer par\n                            "
                              ),
                            ]
                          ),
                          _vm._v(" "),
                          _c("div", { ref: "filtersMobileTarget" }),
                        ]
                      ),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      ref: "filtersWrapper",
                      staticStyle: { display: "contents" },
                    },
                    [
                      !_vm.hideEmptySearchFilters
                        ? _c("device-list-filters", {
                            attrs: {
                              "search-mode": _vm.searchMode,
                              "first-party-only-checked": _vm.orangeOnly,
                              "search-categories": _vm.searchCategories,
                              "selected-search-category":
                                _vm.selectedSearchCategory,
                              "brand-checkboxes": _vm.brandCheckboxes,
                              "price-checkboxes": _vm.priceCheckboxes,
                              "note-checkboxes": _vm.noteCheckboxes,
                              "selector-groups-checkboxes":
                                _vm.selectorGroupsCheckboxes,
                              "status-checkboxes": _vm.statusCheckboxes,
                              "department-label": _vm.currentDepartment?.label,
                              categories: _vm.currentDepartment?.categories,
                              "selected-category": _vm.currentCategorySeoId,
                              "selected-sub-category":
                                _vm.currentSubCategorySeoId,
                              "brand-search-label":
                                _vm.dto.filters.brandSearchLabel,
                              "brand-search-value": _vm.brandSearchValue,
                              "collapsed-brands-label":
                                _vm.dto.filters.collapsedBrandsLabel,
                              "not-collapsed-brands-label":
                                _vm.dto.filters.notCollapsedBrandsLabel,
                              "results-accessible-label":
                                _vm.filtersAndSortAccessibleLabel,
                              "third-party-enabled": _vm.dto.thirdPartyEnabled,
                              "shop-brand": _vm.dto.brand,
                            },
                            on: {
                              "toggle-first-party-only-filter":
                                _vm.toggleOrangeOnly,
                              "update-brand-search-value":
                                _vm.updateBrandSearchValue,
                              "select-search-category-filter":
                                _vm.selectSearchCategory,
                              "toggle-brand-filter": _vm.toggleBrand,
                              "toggle-price-filter": _vm.togglePrice,
                              "toggle-note-filter": _vm.toggleNote,
                              "toggle-selector-filter": _vm.toggleSelector,
                              "select-category-filter": _vm.selectCategory,
                              "toggle-status-filter": _vm.toggleStatus,
                            },
                          })
                        : _vm._e(),
                    ],
                    1
                  ),
                ]),
                _vm._v(" "),
                _c(
                  "section",
                  { attrs: { "aria-label": "Liste des produits" } },
                  [
                    _c(
                      "div",
                      { staticClass: "row" },
                      _vm._l(_vm.devices, function (device, index) {
                        return _c(
                          "article",
                          {
                            key: index,
                            staticClass:
                              "col-12 col-md-6 col-xxl-4 selector-accessory-card mb-1 d-flex flex-column",
                            attrs: { id: "productsList" },
                          },
                          [
                            _c("device-card", {
                              attrs: {
                                device: device,
                                "advantage-messages": _vm.dto.advantageMessages,
                                "has-third-parties-in-cart":
                                  _vm.hasThirdPartiesInCart,
                                "funding-details": _vm.dto.fundingDetails,
                                "enable-price-inversion":
                                  _vm.enablePriceInversion,
                                index: index,
                                "search-mode": _vm.searchMode,
                                "text-search": _vm.textSearch,
                              },
                              on: {
                                fundingDetailsClick:
                                  _vm.handleFundingDetailsClick,
                                energyLabelClick: _vm.handleEnergyLabelClick,
                              },
                            }),
                          ],
                          1
                        )
                      }),
                      0
                    ),
                    _vm._v(" "),
                    _vm.searchMode &&
                    _vm.devices.length === 0 &&
                    !_vm.showAccessorySpinner &&
                    !_vm.hasActiveSearchFilters
                      ? _c(
                          "div",
                          {
                            staticClass:
                              "d-flex flex-column align-items-center text-center py-5",
                          },
                          [
                            _c("p", { staticClass: "h3" }, [
                              _vm._v(
                                "\n                            Oups, on ne trouve aucun résultat pour « " +
                                  _vm._s(_vm.textSearch) +
                                  " »\n                        "
                              ),
                            ]),
                            _vm._v(" "),
                            _vm._m(0),
                          ]
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.showAccessorySpinner
                      ? _c(
                          "div",
                          { staticClass: "d-flex justify-content-center" },
                          [
                            _c("ob1-progress-indicators", {
                              attrs: { type: "undetermined", size: 50 },
                            }),
                          ],
                          1
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        staticClass:
                          "d-flex flex-column align-items-center py-2",
                      },
                      [
                        _vm.showMoreAccessoriesButton
                          ? _c("bouton", {
                              staticClass: "mx-0 my-1",
                              attrs: {
                                id: "showMoreButton",
                                label: "Voir plus d'accessoires",
                                "is-primary": false,
                                "is-disabled": _vm.showAccessorySpinner,
                              },
                              on: {
                                click: function ($event) {
                                  return _vm.getMoreAccessories()
                                },
                              },
                            })
                          : _vm._e(),
                        _vm._v(" "),
                        _c("bouton", {
                          staticClass: "visually-hidden-focusable d-xl-none",
                          attrs: {
                            label:
                              "Revenir aux filtres pour affiner la recherche",
                            "is-primary": false,
                            "data-bs-toggle": "modal",
                            "data-bs-target": "#filters-modal",
                            "aria-controls": "filters-modal",
                          },
                        }),
                        _vm._v(" "),
                        _c("bouton", {
                          staticClass:
                            "visually-hidden-focusable d-none d-xl-block",
                          attrs: {
                            label:
                              "Revenir aux filtres pour affiner la recherche",
                            "is-primary": false,
                          },
                          on: { click: _vm.goToFilters },
                        }),
                      ],
                      1
                    ),
                  ]
                ),
              ]
            ),
          ]),
        ],
        1
      ),
      _vm._v(" "),
      _vm.editorialTitle && _vm.editorialDescription
        ? _c("div", { staticClass: "container-fluid mt-2" }, [
            _c("h2", [_vm._v(_vm._s(_vm.editorialTitle))]),
            _vm._v(" "),
            _c("p", {
              staticClass: "text-mw",
              domProps: { innerHTML: _vm._s(_vm.editorialDescription) },
            }),
          ])
        : _vm._e(),
      _vm._v(" "),
      _vm.displayLegalMentions
        ? _c("div", { staticClass: "bg-gray2 mt-2" }, [
            _c(
              "div",
              { staticClass: "container-fluid py-1" },
              [
                _vm.pxfEnabled &&
                _vm.dto.legalMentions.pxfMention &&
                !_vm.hasThirdPartiesInCart
                  ? _c("p", {
                      staticClass: "fw-bold mb-0",
                      domProps: {
                        innerHTML: _vm._s(_vm.dto.legalMentions.pxfMention),
                      },
                    })
                  : _vm._e(),
                _vm._v(" "),
                _vm.cb4xEnabled &&
                _vm.dto.legalMentions.cb4xMention &&
                !_vm.hasThirdPartiesInCart
                  ? _c("legal-mentions4x-cb", {
                      attrs: {
                        label: _vm.dto.legalMentions.cb4xMention,
                        "popin4x-cb": _vm.dto.legalMentions.popin4xCb,
                        "pxf-legal-mentions-text":
                          _vm.dto.legalMentions.pxfMention,
                      },
                    })
                  : _vm._e(),
              ],
              1
            ),
          ])
        : _vm._e(),
      _vm._v(" "),
      _vm.selectedFundingDetailVersion
        ? _c("pxf-cb4x-modal", {
            attrs: {
              "modal-id": "funding-details-popin",
              "display-cb4x": _vm.selectedFundingDetailVersion.cb4xAvailable,
              "display-pxf": _vm.selectedFundingDetailVersion.pxfAvailable,
              "device-name": _vm.selectedFundingDetailVersion.deviceName,
            },
            scopedSlots: _vm._u(
              [
                _vm.selectedFundingDetailVersion.cb4xAvailable
                  ? {
                      key: "cb4x-content",
                      fn: function () {
                        return [
                          _vm.dto.fundingDetails.cb4xPopin.withFees
                            ? _c("paying-detail-cb4x-modal-content", {
                                attrs: {
                                  "modal-id": "funding-details-popin",
                                  "oney-merchant-guid":
                                    _vm.dto.fundingDetails.cb4xPopin
                                      .oneyMerchantGuid,
                                  "oney-widget-src":
                                    _vm.dto.fundingDetails.oneyWidgetSrc,
                                  "counter-delay":
                                    _vm.dto.fundingDetails.counterDelay,
                                  amount:
                                    _vm.selectedFundingDetailVersion
                                      .discountedPriceInCents / 100,
                                  "header-block":
                                    _vm.dto.fundingDetails.cb4xPopin
                                      .headerBlock,
                                  "how-to-benefit":
                                    _vm.dto.fundingDetails.cb4xPopin
                                      .howToBenefit,
                                  cgu: _vm.dto.fundingDetails.cb4xPopin.cgu,
                                  illustration:
                                    _vm.dto.fundingDetails.cb4xPopin.imageZen,
                                  "pxf-legal-mentions-text":
                                    _vm.dto.legalMentions.pxfMention,
                                },
                              })
                            : _vm.selectedFundingDetailVersion
                                .spreadingPrice4xCbWithoutFees
                            ? _c("cb4x-modal-content", {
                                attrs: {
                                  "header-block":
                                    _vm.dto.fundingDetails.cb4xPopin
                                      .headerBlock,
                                  "payment-block":
                                    _vm.dto.fundingDetails.cb4xPopin
                                      .paymentBlock,
                                  "payment-simulation-block":
                                    _vm.dto.fundingDetails.cb4xPopin
                                      .paymentSimulationBlock,
                                  "how-to-benefit":
                                    _vm.dto.fundingDetails.cb4xPopin
                                      .howToBenefit,
                                  faq: _vm.dto.fundingDetails.cb4xPopin
                                    .faqBlock,
                                  cgu: _vm.dto.fundingDetails.cb4xPopin.cgu,
                                  "monthly-price":
                                    _vm.selectedFundingDetailVersion
                                      .spreadingPrice4xCbWithoutFees
                                      .monthlyPrice,
                                  "first-monthly-price":
                                    _vm.selectedFundingDetailVersion
                                      .spreadingPrice4xCbWithoutFees
                                      .firstMonthlyPrice,
                                  "one-shot-price":
                                    _vm.selectedFundingDetailVersion
                                      .spreadingPrice4xCbWithoutFees
                                      .oneShotPrice,
                                  illustration:
                                    _vm.dto.fundingDetails.cb4xPopin.imageZen,
                                  "pxf-legal-mentions-text":
                                    _vm.dto.legalMentions.pxfMention,
                                },
                              })
                            : _vm._e(),
                        ]
                      },
                      proxy: true,
                    }
                  : null,
                _vm.selectedFundingDetailVersion.pxfAvailable
                  ? {
                      key: "pxf-content",
                      fn: function () {
                        return [
                          _c("pxf-modal-content", {
                            attrs: {
                              "header-block-dto":
                                _vm.dto.fundingDetails.pxfPopin.headerBlockDto,
                              "example-pxf-data":
                                _vm.dto.fundingDetails.pxfPopin.examplePxfData,
                              "example-pxf-tab-subtitle":
                                _vm.dto.fundingDetails.pxfPopin
                                  .examplePxfTabSubtitle,
                              "example-pxf-tab-title":
                                _vm.dto.fundingDetails.pxfPopin
                                  .examplePxfTabTitle,
                              "version-pxf-data":
                                _vm.selectedFundingDetailVersion.versionPxfData,
                              "version-pxf-tab-title":
                                _vm.dto.fundingDetails.pxfPopin
                                  .versionPxfTabTitle,
                              "pxf-legal-mentions-text":
                                _vm.dto.fundingDetails.pxfPopin
                                  .pxfLegalMentionsText,
                              illustration:
                                _vm.dto.fundingDetails.pxfPopin.imageZen,
                              "financing-block":
                                _vm.dto.fundingDetails.pxfPopin.financingBlock,
                              cgu: _vm.dto.fundingDetails.pxfPopin.cguDto,
                              "how-to-benefit-dto":
                                _vm.dto.fundingDetails.pxfPopin.howToBenefitDto,
                            },
                          }),
                        ]
                      },
                      proxy: true,
                    }
                  : null,
              ],
              null,
              true
            ),
          })
        : _vm._e(),
      _vm._v(" "),
      _vm.selectedEnergyLabel
        ? _c("energy-label-popin", {
            attrs: {
              "energy-label": _vm.selectedEnergyLabel,
              "modal-id": "energy-label-popin",
            },
          })
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("ul", {}, [
      _c("li", [_vm._v("Vérifiez l’orthographe de votre requête")]),
      _vm._v(" "),
      _c("li", [_vm._v("Utilisez d’autres termes de recherche")]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }